import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { Carriers } from "../fulfillments/fulfillment-carriers-and-services";

export const ThirdPartyBillingAccountSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  carrier: createEnum(Carriers, { enumName: "Carriers" }),
  accountNumber: z.string(),
  accountName: z.string(),
  country: z.string(),
  postalCode: z.string(),
  hidden: z.boolean().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ThirdPartyBillingAccount = z.infer<
  typeof ThirdPartyBillingAccountSchema
>;

export const CreateThirdPartyBillingAccountSchema =
  ThirdPartyBillingAccountSchema.omit({
    _id: true,
    createdAt: true,
    updatedAt: true,
  });

export type CreateThirdPartyBillingAccount = z.infer<
  typeof CreateThirdPartyBillingAccountSchema
>;
